import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Collapse, Row, Col
} from 'reactstrap';
import slackLogo from 'src/components/VariantOnboarding/assets/slackLogo.png';
import jiraLogo from 'src/components/VariantOnboarding/assets/jiraLogo.png';
import microsoftTeamsLogo from 'src/components/VariantOnboarding/assets/microsoftTeamsLogo.png';
import serviceNowLogo from 'src/components/VariantOnboarding/assets/serviceNowLogo.png';

import {
  trackEvent,
  TRACKS_THIRD_ARM,
} from 'src/util/segment-storeless';

import TrackedLink from 'src/components/TrackedLink';
import ToggleStep from './ToggleStep';
import styles from './style.module.css';

const IntegrationsStep = (props) => {
  const { isComplete, firstService, getSegmentProps } = props;
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    if (!isOpen && isComplete) {
      trackEvent(
        TRACKS_THIRD_ARM.see_step_again,
        getSegmentProps({
          step_name: 'integrations'
        })
      );
    }
    setIsOpen(!isOpen);
  };
  const collapseStyles = isOpen ? styles.stepCollapse : null;
  const hasService = Object.keys(firstService).length > 0;

  const IntegrationsButton = () => {
    const ctaType = 'Take Me There';
    return (
      <div className="text-center">
        <TrackedLink
          className="btn btn-primary btn-sm"
          href={`/service-directory/${firstService.id}/integrations`}
          data-test="create-integration"
          trackName={TRACKS_THIRD_ARM.integration_link}
          trackProperties={getSegmentProps({ ctaType })}
        >
          { ctaType }
        </TrackedLink>
      </div>
    );
  };

  const CreateService = () => {
    const ctaType = 'Create a Service';
    return (
      <div className="text-center">
        <TrackedLink
          className="btn btn-primary btn-sm"
          href="/services/new"
          data-test="create-service"
          trackName={TRACKS_THIRD_ARM.integration_link}
          trackProperties={getSegmentProps({ ctaType })}
        >
          { ctaType }
        </TrackedLink>
      </div>
    );
  };

  return (
    <div>
      <ToggleStep
        isOpen={isOpen}
        toggle={toggle}
        stepNumber="5"
        stepTitle="Connect PagerDuty with your other tools"
        isCompleted={isComplete}
      />
      <Collapse className={collapseStyles} isOpen={isOpen} data-test="onboarding-integration-step-toggle">
        <Row>
          <Col>
            <p>
              Level up and expand the functionality of your PagerDuty account by adding Integrations
              and Extensions to your services.
            </p>
            <p>
              You can bring data into PagerDuty from your monitoring, logging, and analytics tools.
              You can also add extensions to Hipchat, Zapier, Slack, Flowdock, Socialcast and other
              tools to notify your team about PagerDuty incidents as they happen.
            </p>

            { hasService ? IntegrationsButton() : CreateService() }

          </Col>
          <Col>
            <Row>
              <Col className="h-100 pt-1">
                <img
                  className="w-100 h-100"
                  src={slackLogo}
                  alt="Slack Logo"
                />
              </Col>
              <Col className="h-100 pt-1">
                <img
                  className="w-100 h-100"
                  src={microsoftTeamsLogo}
                  alt="Microsoft Teams Logo"
                />
              </Col>
            </Row>
            <Row>
              <Col className="h-100 pt-1">
                <img
                  className="w-100 h-100"
                  src={serviceNowLogo}
                  alt="Service Now Logo"
                />
              </Col>
              <Col className="h-100 pt-1">
                <img
                  className="w-100 h-100"
                  src={jiraLogo}
                  alt="Jira Logo"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Collapse>
    </div>
  );
};

IntegrationsStep.defaultProps = {
  firstService: {
    id: '',
    name: '',
  },
};

IntegrationsStep.propTypes = {
  isComplete: PropTypes.bool.isRequired,
  getSegmentProps: PropTypes.func.isRequired,
  firstService: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
};

export default IntegrationsStep;
